  // __fast_options lives inline in layout/theme.liquid: this file is deferred,
  // and Fast Simon reads the options at boot, often before it runs.

  const colorMap = {
    black: 'Noir',
    beige: 'Beige',
    blue: 'Bleu',
    blush: 'Rose poudré',
    bone: 'Os',
    bordeaux: 'Bordeaux',
    brown: 'Brun',
    camel: 'Camel',
    charcoal: 'Anthracite',
    cherry: 'Cerise',
    chestnut: 'Châtaigne',
    cobalt: 'Cobalt',
    coco: 'Coco',
    coral: 'Corail',
    cream: 'Crème',
    fuchsia: 'Fuchsia',
    green: 'Vert',
    grey: 'Gris',
    khaki: 'Kaki',
    lilac: 'Lilas',
    natural: 'Naturel',
    navy: 'Marine',
    onyx: 'Onyx',
    orange: 'Orange',
    pink: 'Rose',
    platinum: 'Platine',
    plum: 'Prune',
    purple: 'Violet',
    rust: 'Rouille',
    silver: 'Argent',
    taupe: 'Taupe',
    violet: 'Violet',
    walnut: 'Noyer',
    white: 'Blanc',
    wine: 'Vin',
    gray: 'Gris',
    red: 'Rouge',
    rose: 'Rose',
    sand: 'Sable',
    yellow: 'Jaune',
    chocolate: 'Chocolat',
    biscotti: 'Biscotti',
    bordeau: 'Bordeau',
    brunette: 'Brunette',
    butter: 'Beurre',
    cognac: 'Cognac',
    cuoio: 'Cuoio',
    earth: 'Terre',
    honey: 'Miel',
    ice: 'Gris glacé',
    jeans: 'Jeans',
    'jeans blue': 'Bleu jeans',
    military: 'Camouflage',
    moka: 'Moka',
    'off white': 'Blanc cassé',
    pebble: 'Pierre',
    sage: 'Sauge',
    stone: 'Galet',
    toffee: 'Caramel',
    london: 'Londres',
    chalk: 'Craie',
    'light grey': 'Gris Clair',
    anthracite: 'Anthracite',
    'anthracite/preto': 'Anthracite/Noir',
    'ash/grigio': 'Gris Cendre/Grigio',
    'beige stardust': 'Beige Scintillant',
    'beige/gray': 'Beige/Gris',
    'bianco/preto': 'Bianco/Preto',
    'black /black': 'Noir/Noir',
    'black antilope': 'Noir Antilope',
    'black camo': 'Noir Camo',
    'black iron': 'Noir Fer',
    'black leather': 'Cuir Noir',
    'black metal': 'Noir Métal',
    'black mix': 'Mélange Noir',
    'black pearl': 'Perle Noire',
    'black pearl/beige': 'Noir Perlé/Beige',
    'black stardust': 'Noir Scintillant',
    'black stellare': 'Noir Scintillant',
    'black suede': 'Suède Noir',
    'black vintage print': 'Noir Imprimé Vintage',
    'black white': 'Noir Blanc',
    'black/black': 'Noir/Noir',
    'black/blue/dark teal': 'Noir/Bleu/Sarcelle',
    'black/bone/multi': 'Noir/Os/Multi',
    'black/bordeaux': 'Noir/Bordeaux',
    'black/brown fur': 'Noir/Brun Fourrure',
    'black/chalk': 'Noir/Craie',
    'black/charcoal': 'Noir/Charbon',
    'black/crystal': 'Noir Cristal',
    'black/elm bark': 'Noir/Écorce',
    'black/gold': 'Noir/Or',
    'black/grey fur': 'Noir/Gris/Fourrure',
    'black/khaki': 'Noir/Kaki',
    'black/navy': 'Noir/Bleu Marine',
    'black/silver': 'Noir/Argent',
    'black/white': 'Noir/Blanc',
    'black/white/black': 'Noir/Blanc/Noir',
    bordo: 'Bordeaux',
    'branco/preto': 'Blanc/Noir',
    brandy: 'Brandy',
    'bronze stellare': 'Bronze Stellaire',
    'brown/black': 'Brun/Noir',
    'brown/white': 'Brun/Blanc',
    buffalo: 'Buffle',
    'buffalo plaid': 'Carreaux Buffalo',
    burgundy: 'Bourgogne',
    camoflage: 'Camouflage',
    caramel: 'Caramel',
    castanho: 'Marron',
    champagne: 'Champagne',
    'charcoal iron': 'Charbon/Fer',
    'charcoal stellare flash': 'Charbon Stellaire Flash',
    chalk: 'Craie',
    clear: 'Transparent',
    'cognac/beige': 'Cognac/Beige',
    'cognac/chestnut': 'Cognac/Châtaigne',
    'cognac/ebony': 'Cognac/Ébène',
    'cognac/navy': 'Cognac/Bleu Marine',
    copper: 'Cuivré',
    'creme suede': 'Suède Crème',
    'cuopio / cream': 'Cuopio/Crème',
    'current red': 'Rouge Groseille',
    'dark blue': 'Bleu Foncé',
    'dark brown': 'Brun Foncé',
    'dark brown/black': 'Brun Foncé/Noir',
    'dark brown/military': 'Brun Foncé/Militaire',
    'dark brown/taupe': 'Brun Foncé/Taupe',
    'dark emerald': 'Émeraude Foncé',
    'dark grey': 'Gris Foncé',
    'dark grey/black': 'Gris Foncé/Noir',
    'dark oak': 'Chêne Foncé',
    'dark red': 'Rouge Foncé',
    'dk brown/black': 'Brun Foncé/Noir',
    'dk grey': 'Gris Foncé',
    'dusty pink': 'Rose Poudré',
    ebony: 'Ébène',
    'ecru suede': 'Suède Écru',
    gold: 'Doré',
    'gold metal': 'Métal Doré',
    'gold metal stellare': 'Métal Doré Stellaire',
    'gold stellare': 'Doré Stellaire',
    'gold/beige': 'Doré/Beige',
    golden: 'Doré',
    graphite: 'Graphite',
    'graphite/silver': 'Graphite/Argent',
    'grey/black': 'Gris/Noir',
    gunmetal: 'Canon de Fusil',
    'ice/grey/navy': 'Glace/Gris/Bleu Marine',
    ivory: 'Ivoire',
    'khaki/preto': 'Kaki/Noir',
    lamb: 'Agneau',
    'light grey': 'Gris Clair',
    'light ice/black': 'Glace Claire/Noir',
    'light pink': 'Rose Clair',
    lightgrey: 'Gris Clair',
    'lino suede': 'Suède Lin',
    magnolia: 'Magnolia',
    marino: 'Marine',
    marrone: 'Marron',
    'military green/black': 'Vert Militaire/Noir',
    'military/crystal': 'Militaire/Crystal',
    'military/military camo': 'Militaire/Camouflage Militaire',
    'mink suede': 'Suède Vison',
    multi: 'Multicolore',
    'multi black/white': 'Multicolore Noir/Blanc',
    'multi color': 'Multicolore',
    multicolor: 'Multicolore',
    mustard: 'Moutarde',
    'n/c': 'Sans Couleur',
    'navy/black': 'Bleu Marine/Noir',
    'navy/grey': 'Bleu Marine/Gris',
    'navy/silver': 'Bleu Marine/Argent',
    'navy/taupe': 'Bleu Marine/Taupe',
    nero: 'Noir',
    'neon green': 'Vert Néon',
    'neon lime': 'Citron Néon',
    'neon pink': 'Rose Néon',
    'neon pink/grey/black': 'Rose Néon/Gris/Noir',
    neutral: 'Neutre',
    'no color': 'Sans Couleur',
    'nude leather': 'Cuir Nude',
    olive: 'Olive',
    'olive camo': 'Camouflage Olive',
    'olive/black': 'Olive/Noir',
    'olive/dark brown': 'Olive/Brun Foncé',
    'olivia/preto': 'Olivia/Noir',
    offwhite: 'Blanc Cassé',
    'optical white': 'Blanc Optique',
    'ox blood': 'Bordeaux Foncé',
    oxblood: 'Bordeaux Foncé',
    'pewter fly': 'Étain',
    'pink gold stellare flash': 'Or Rose Stellaire Flash',
    'quarzo rosa': 'Quartz Rose',
    'red stellare': 'Rouge Stellaire',
    'red/bone': 'Rouge/Os',
    'red/bone/multi': 'Rouge/Os/Multicolore',
    'red/black': 'Rouge/Noir',
    'rose gold / black': 'Or Rose/Noir',
    rustic: 'Rustique',
    'rustic/black': 'Rustique/Noir',
    'safari / white': 'Safari/Blanc',
    'sand/black': 'Sable/Noir',
    sapphire: 'Saphir',
    shark: 'Gris Requin',
    'shark-teal': 'Requin/Sarcelle',
    'shark/bone': 'Requin/Os',
    'silver stellare flash': 'Argent Stellaire Flash',
    tabacco: 'Tabac',
    tan: 'Fauve',
    'tan/church': 'Fauve/Church',
    'taupe -violet': 'Taupe/Violet',
    'taupe / camello': 'Taupe/Camel',
    'taupe/black': 'Taupe/Noir',
    teal: 'Sarcelle',
    'testa di moro': 'Chocolat',
    turquoise: 'Turquoise',
    'walnut/setter': 'Noyer/Setter',
    'white iron': 'Blanc Fer',
    'white marble': 'Marbre Blanc',
    'white pearl': 'Perle Blanche',
    'white stellare': 'Blanc Stellaire',
    'white-coral': 'Blanc/Corail',
    'white-neon lime': 'Blanc/Citron Néon',
    'white/navy': 'Blanc/Bleu Marine',
    'white/silver': 'Blanc/Argent',
    whiskey: 'Whisky',
    woody: 'Bois',
  };


  const BADGE_TRANSLATIONS_FR = {
    "NEW": "NOUVEAU",
    "BESTSELLER": "MEILLEURE VENTE",
    "3-IN-1": "3-EN-1",
    "REVERSIBLE": "RÉVERSIBLE",
    "New": "NOUVEAU",
    "Bestseller": "MEILLEURE VENTE",
    "Reversible": "RÉVERSIBLE",
    "3-In-1": "3-EN-1",
  };


  /* get all products to loop on */
  function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
  }

  /* remove label */
  function removeLabel(productElement) {
    const label = productElement.querySelector('.my-promo-label');
    if (label) {
      label.remove();
    }
  }

  function addSaleLabel(productElement, data) {
    const save = Math.round(((data.comparePrice - data.price) * 100) / data.comparePrice);

    const compareelement = productElement.querySelector('.compare-container');

    if (compareelement && productElement.querySelectorAll('.my-promo-labels').length === 0) {
      // Determine label text based on Shopify locale
      const labelText =
        Shopify.locale === 'fr' ? `Économisez ${save}%` : `Save ${save}%`;

      compareelement.insertAdjacentHTML(
        'afterend',
        `<div class="my-promo-labels">${labelText}</div>`
      );

      productElement.querySelector('.info-container').style.gridTemplateAreas =
        '"title title title title" "compare compare price price" "promo promo promo promo" "colorSwatches colorSwatches colorSwatches colorSwatches"';
    }
  }

  function GetColorName(product) {
    const firstObjectWithColor = product.find((item) => 'Color' in item.attributes);
    const firstColor = firstObjectWithColor?.attributes.Color; // Using optional chaining for safety
    const formattedColor = firstColor ? firstColor.toLowerCase().replace('/', '_').replace(/ /g, '_') : null;
    return formattedColor;
  }

  /* Function to sanitize the color name */
  function sanitizeColorName(colorName) {
    return colorName.replace(/[^a-zA-Z0-9-_]/g, '_'); // Replace all non-alphanumeric characters with _
  }  

  // custom-tooltip-english-french
  function swatchHoverCallback(data) {
    if (data) {
      const swatchWrapperElement = data.swatchElement;
      setTimeout(() => {
        const tooltip = swatchWrapperElement.querySelector('.fs-serp-tooltip');

        if (tooltip) {
          const originalText = tooltip.innerHTML.toLowerCase();

          // Check Shopify locale and apply translation only for French
          if (Shopify.locale === 'fr' && colorMap[originalText]) {
            tooltip.innerHTML = colorMap[originalText];
          } else {
            tooltip.innerHTML = originalText.charAt(0).toUpperCase() + originalText.slice(1); // Capitalize
          }
        }

        let productElement = data.swatchElement.closest('.fs-product-card');
        let productTitleElement = productElement?.querySelector('.fs-product-title');

        if (productTitleElement) {
          let titleText = productTitleElement.textContent;
          let newText = titleText.replace(/ - .*/, '');
          productTitleElement.textContent = newText;
        }
      }, 1);
    }
  }

  window.addEventListener('fs-custom-events-product-swatch-on-hover', (e) => {
    swatchHoverCallback(e.detail);
  });

  /* helper: remove existing badges */
  function removeBadge(productElement) {
    productElement.querySelectorAll('.fs-metafield-badge').forEach((b) => b.remove());
  }

  /* helper: add badge with unique index class */
  function addBadge(productElement, badgeText, index) {
    if (!badgeText) return;

    const lang = Shopify.locale;
    let displayText = badgeText;
    //translate badges to France
    if (lang === 'fr' && BADGE_TRANSLATIONS_FR[badgeText]) {
      displayText = BADGE_TRANSLATIONS_FR[badgeText];
    }
    let badgesContainer = productElement.querySelector('.image-wrapper .fs-badges-wrapper');
    if (!badgesContainer) {
      const wrapper = productElement.querySelector('.image-wrapper');
      if (wrapper) {
        wrapper.insertAdjacentHTML('afterbegin', `<div class="fs-badges-wrapper"></div>`);
        badgesContainer = wrapper.querySelector('.fs-badges-wrapper');
      }
    }

    if (badgesContainer) {
      badgesContainer.insertAdjacentHTML(
        'beforeend',
        `<div class="fs-metafield-badge fs-metafield-badge-${index + 1}">
         ${displayText}
       </div>`
      );
    }
  }

  /* helper: get metafield/attribute values (limit 2) */
  function getAttributeValues(att, name, limit = 2) {
    let values = [];
    if (typeof att !== 'undefined' && att !== null) {
      for (let key in att) {
        if (att[key][0] === name) {
          values = att[key][1].slice(0, limit); // take up to 2
          break;
        }
      }
    }
    return values;
  }

  // Fast Simon writes data-product-id from a JS number, so a composite id above
  // Number.MAX_SAFE_INTEGER reaches the card rounded ("...499" -> "...500") and
  // misses products[id]. Such a card got no carousel, and when Fast Simon reused
  // it for another product it kept the previous product's carousel and title.
  const roundedIdIndex = new WeakMap();

  function candidateKeys(products, cardId) {
      let index = roundedIdIndex.get(products);
      if (!index) {
          index = new Map();
          for (const key of Object.keys(products)) {
              const rounded = String(Number(key));
              if (rounded !== key) index.set(rounded, [...(index.get(rounded) || []), key]);
          }
          roundedIdIndex.set(products, index);
      }
      const rounded = index.get(cardId) || [];
      return products[cardId] ? [cardId, ...rounded] : rounded;
  }

  function variantOf(url) {
      return /[?&]variant=(\d+)/.exec(url || "")?.[1] || null;
  }

  // Two keys can round to the same id; the card's variant link tells them apart.
  function productKeyForCard(products, productElement) {
      const cardId = productElement.dataset.productId;
      if (!products || !cardId) return null;

      const keys = candidateKeys(products, cardId);
      if (keys.length < 2) return keys[0] || null;

      const cardVariant = variantOf(productElement.querySelector("a.fs-product-main-image-wrapper")?.getAttribute("href"));
      const byVariant = cardVariant ? keys.filter(key => variantOf(products[key].productURL) === cardVariant) : [];
      if (byVariant.length === 1) return byVariant[0];

      return products[cardId] ? cardId : null;
  }


  function normalizeColorKey(str) {
      return (str || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  // Only used as a fallback when nothing matches exactly.
  function normalizeColorKeySorted(str) {
      return (str || "")
          .toUpperCase()
          .split(/[^A-Z0-9]+/)
          .filter(Boolean)
          .sort()
          .join("");
  }

  // A colour is sometimes written as a repeated pair - "BLACK/BLACK" - while
  // the filenames spell it once ("..._BLACK_1_hash.jpg"). Comparing the set of
  // distinct tokens lets those two meet.
  function normalizeColorKeyDistinct(str) {
      return [...new Set(
          (str || "").toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean)
      )].sort().join("");
  }

  function imageFileStem(url) {
      const fileName = url.split("/").pop().split("?")[0];
      return fileName.replace(/\.[a-z0-9]+$/i, "");
  }

  // Candidate colour keys for every "_"-delimited segment of the filename,
  // with the trailing image index removed ("BLACKLEATHER-1" -> "BLACKLEATHER").
  function imageColorKeys(url) {
      return imageFileStem(url).split("_").map(segment => {
          const withoutIndex = segment.replace(/[-\s]?[0-9]+[A-Za-z]?$/, "");
          return {
              exact: normalizeColorKey(withoutIndex),
              sorted: normalizeColorKeySorted(withoutIndex),
              distinct: normalizeColorKeyDistinct(withoutIndex)
          };
      });
  }

  function imagesForColor(images, colorName) {
      const exactKey = normalizeColorKey(colorName);
      if (!exactKey) return [];

      const keyed = images.map(url => ({ url, keys: imageColorKeys(url) }));

      // Try the strictest comparison first and loosen only while the colour is
      // still short of a navigable set. Each pass ADDS to the last rather than
      // replacing it: one colour can be photographed across two shoots with two
      // naming styles ("FW23_Patch_BlackBlack_1" + "FW24_PATCH_BLACK_2-2"), and
      // stopping at the first pass that found anything kept only the one photo.
      const sortedKey = normalizeColorKeySorted(colorName);
      const distinctKey = normalizeColorKeyDistinct(colorName);
      const passes = [
          k => k.exact === exactKey,
          k => k.sorted === sortedKey,
          k => k.distinct === distinctKey
      ];

      const hits = new Set();

      for (const pass of passes) {
          if (hits.size >= MIN_CAROUSEL_IMAGES) break;
          for (const item of keyed) {
              if (item.keys.some(pass)) hits.add(item.url);
          }
      }

      return images.filter(url => hits.has(url));
  }



  const SIZE_SUFFIX = /_(large|medium|small|grande|compact|icon|pico|thumb|master|[0-9]+x[0-9]*)$/i;
  const TRAILING_INDEX = /[_-][0-9]+(-[0-9]+)?[A-Za-z]?$/;

  function imageStemNoSize(url) {
      return imageFileStem(url).replace(SIZE_SUFFIX, "");
  }

  // Shopify appends a random token when a file is re-uploaded under a name that
  // already exists - "FW26_FERO_2.0_MILITARY_GREEN-DARK_BROWN_1_scwkn6.jpg", or a
  // whole UUID. That token sits AFTER the image index, so the index can't be
  // found until it comes off. Most FW26 files carry one, which is why their
  // carousels were falling back to cycling every colour.
  const UPLOAD_TOKEN = /^(?=[a-z0-9]*[a-z])[a-z0-9]{5,8}$|^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  const INDEX_SEGMENT = /^[0-9]+(-[0-9]+)?[A-Za-z]?$/;
  const ATTACHED_INDEX = /-[0-9]+[A-Za-z]?$/;

  function anchorPrefix(url) {
      const stem = imageStemNoSize(url);
      const segments = stem.split("_");

      while (segments.length > 1 && UPLOAD_TOKEN.test(segments[segments.length - 1])) {
          segments.pop();
      }

      const last = segments[segments.length - 1];

      if (segments.length > 1 && INDEX_SEGMENT.test(last)) {
          segments.pop();
          return segments.join("_");
      }

      if (ATTACHED_INDEX.test(last)) {
          segments[segments.length - 1] = last.replace(ATTACHED_INDEX, "");
          return segments.join("_");
      }

      // No index found once the tokens are off - don't guess, keep the old rule.
      return stem.replace(TRAILING_INDEX, "");
  }

  // colour key -> that colour's hero image, taken straight from variant data.
  function colorAnchors(data) {
      const variants = Array.isArray(data?.variants) ? data.variants : [];
      const anchors = new Map();

      for (const variant of variants) {
          const color = variant?.attributes?.Color;
          const imgs = variant?.attributes?.imgs;
          if (typeof color !== "string" || !color.trim()) continue;

          const key = normalizeColorKey(color);
          if (!key || anchors.has(key)) continue;

          const first = Array.isArray(imgs) ? imgs[0] : imgs;
          if (typeof first === "string" && first) {
              anchors.set(key, { color: color.trim(), anchor: first });
          }
      }

      return anchors;
  }

  // The prefix must end on a boundary, so "FW26_GALAXY_RED" can't swallow
  // "FW26_GALAXY_RED-SAND_...": the next character has to be "_" or "-<digit>".
  function imagesForAnchor(images, anchorUrl) {
      const prefix = anchorPrefix(anchorUrl);
      if (!prefix) return [];

      return images.filter(url => {
          const stem = imageStemNoSize(url);
          if (stem === prefix) return true;
          if (!stem.startsWith(prefix)) return false;

          const rest = stem.slice(prefix.length);
          return rest[0] === "_" || /^-[0-9]/.test(rest);
      });
  }

  // Best available image set for one colour on this card.
  // A carousel needs at least two images to be navigable. A grouping that
  // resolves to a single image is worse than no grouping at all: the arrows
  // still render but do nothing. That is what broke roughly half the catalogue
  // after per-colour grouping was introduced.
  //
  // The FW25/SS25 footwear naming ("FW25_LITEBASE-MULE_WHITE-BLACK_1-1.jpg")
  // is the exception, not the rule. Most of the older catalogue looks like
  // "FW22_HEIDI_Mustard_2_lsq4pl_ghhdgt.jpg", where the trailing tokens are
  // random hashes rather than an image index, so the anchor prefix degenerates
  // to the one file it came from and matches nothing else.
  //
  // So take the best grouping that is actually navigable, and when neither
  // strategy produces one, show the product's full image list - the behaviour
  // this carousel had before per-colour grouping existed.
  const MIN_CAROUSEL_IMAGES = 2;

  // The variant hero image is the one image we know belongs to this colour.
  // Whatever set we end up showing, it has to be the one on screen first,
  // otherwise two cards for the same product open on the same photo and read
  // as duplicates - the original complaint.
  function leadWithOwnImage(list, anchorUrl) {
      if (!anchorUrl) return list;

      const anchorStem = imageStemNoSize(anchorUrl);
      const index = list.findIndex(url => imageStemNoSize(url) === anchorStem);

      return index > 0
          ? [list[index], ...list.slice(0, index), ...list.slice(index + 1)]
          : list;
  }

  function imagesForCardColor(images, colorName, anchors) {
      const entry = anchors.get(normalizeColorKey(colorName));
      const anchor = entry ? entry.anchor : null;

      // 1. Variant anchor prefix - exact, and immune to colour-name drift.
      const byAnchor = anchor ? imagesForAnchor(images, anchor) : [];
      if (byAnchor.length >= MIN_CAROUSEL_IMAGES) return leadWithOwnImage(byAnchor, anchor);

      // 2. Colour name vs filename segments - works on the legacy naming,
      //    where the colour sits mid-filename among hash tokens.
      //    Together with the anchor: the variant's hero photo often uses a
      //    different naming style from the rest of its set, so neither signal
      //    alone reaches two images while the two combined do.
      const byName = imagesForColor(images, colorName);
      const ownSet = new Set([...byAnchor, ...byName]);
      const own = images.filter(url => ownSet.has(url));
      if (own.length >= MIN_CAROUSEL_IMAGES) return leadWithOwnImage(own, anchor);

      // 3. Not groupable into a navigable set. Show the whole product so the
      //    arrows still work, but lead with the images we do know are this
      //    colour so the card at least opens on the right photo.
      if (own.length) {
          const ownStems = new Set(own.map(imageStemNoSize));
          const rest = images.filter(url => !ownStems.has(imageStemNoSize(url)));
          return leadWithOwnImage([...own, ...rest], anchor);
      }

      // 4. Nothing identifies this colour at all. Unchanged behaviour.
      return images;
  }

  // The grid splits one product into one card per colour, and a card's variant
  // data only ever describes its own colour. So clicking a sibling swatch has no
  // anchor to work from, and the image silently stays put - which is what made
  // the Black swatch on Fero 2.0 do nothing.
  //
  // The sibling card knows the answer, and both cards carry the same product id,
  // so let every card publish what it knows into a page-level registry and let
  // the click handler read back the union.
  const anchorRegistry = new Map();

  function registerAnchors(productId, anchors) {
      if (!productId) return;

      const known = anchorRegistry.get(productId) || new Map();

      for (const [key, value] of anchors) {
          if (!known.has(key)) known.set(key, value);
      }

      anchorRegistry.set(productId, known);
  }

  // The card's own anchors win; the registry fills in its sibling colours.
  function anchorsForProduct(productId, ownAnchors) {
      const known = productId ? anchorRegistry.get(productId) : null;
      if (!known) return ownAnchors;

      const merged = new Map(known);
      for (const [key, value] of ownAnchors) merged.set(key, value);

      return merged;
  }

  function productColorNames(data) {
      const variants = Array.isArray(data?.variants) ? data.variants : [];
      const names = variants
          .map(variant => variant?.attributes?.Color)
          .filter(color => typeof color === "string" && color.trim())
          .map(color => color.trim());
      return [...new Set(names)];
  }

  // Which colour is this card showing? The grid splits one product into one
  // card per colour, so this has to be decided per card, not per product.
  function currentCardColor(productElement, thumbnailSrc, images, colorNames, anchors) {
      // 1. The swatch Fast Simon marked active on this card.
      const selectedName = productElement
          .querySelector(".color-swatch.selected")
          ?.closest(".color-swatch-container")
          ?.querySelector(".color-swatch-color-name")
          ?.textContent.trim();

      if (selectedName) return selectedName;

      // 2. The card's own thumbnail matched against the variant anchors. This
      //    is skipped when Fast Simon serves its CDN thumbnail, whose filename
      //    is a UUID carrying no colour information.
      if (thumbnailSrc) {
          const thumbStem = imageStemNoSize(thumbnailSrc);

          for (const { color, anchor } of anchors.values()) {
              if (imageStemNoSize(anchor) === thumbStem) return color;
          }

          const byName = colorNames.find(color =>
              imagesForCardColor(images, color, anchors)
                  .some(url => imageStemNoSize(url) === thumbStem)
          );
          if (byName) return byName;
      }

      // 3. The card carries exactly one colour, so there is nothing to choose.
      if (colorNames.length === 1) return colorNames[0];

      return null;
  }


  // The carousel drives Fast Simon's own <img> and arrows instead of building
  // its own: Fast Simon reuses card elements across sort, filter and paging, so
  // anything built into a card can outlive its product. Arrow clicks and swipes
  // are intercepted before Fast Simon's slider sees them, and the photo set is
  // resolved at interaction time - the grid hook fires before the card updates.
  let latestProducts = null;
  const carousels = new WeakMap();
  const productsWithAnchors = new WeakSet();

  // Clicking a swatch switches the card to that colour's own record, which is
  // usually not in the grid payload; without this map the card fell back to
  // Fast Simon's slider (new colour first, then the product's other colours).
  const colourRecords = new Map();

  function registerAllAnchors(products) {
      if (productsWithAnchors.has(products)) return;
      productsWithAnchors.add(products);
      for (const [key, data] of Object.entries(products)) {
          const anchors = colorAnchors(data);
          const alternatives = Array.isArray(data?.alternativeProducts) ? data.alternativeProducts : [];

          for (const alt of alternatives) {
              const color = typeof alt?.color === "string" ? alt.color.trim() : "";
              if (!color) continue;

              // Only trust a colour's hero photo when its filename names that colour:
              // some variants carry another colour's photo (Reading "Cognac" -> BLACK-1).
              const imgs = alt.variants?.[0]?.attributes?.imgs;
              const anchor = Array.isArray(imgs) ? imgs[0] : imgs;
              const colorKey = normalizeColorKey(color);
              const namesColour = typeof anchor === "string" && colorKey && normalizeColorKey(imageFileStem(anchor)).includes(colorKey);
              if (namesColour && !anchors.has(colorKey)) anchors.set(colorKey, { color, anchor });

              if (alt.id != null && !(String(alt.id) in products)) {
                  const record = { key, data, color };
                  colourRecords.set(String(alt.id), record);
                  colourRecords.set(String(Number(alt.id)), record);
              }
          }

          registerAnchors(key, anchors);
      }
  }

  function selectedColorName(productElement) {
      return productElement
          .querySelector(".color-swatch.selected")
          ?.closest(".color-swatch-container")
          ?.querySelector(".color-swatch-color-name")
          ?.textContent.trim() || "";
  }

  function cardImage(productElement) {
      return productElement.querySelector(".fs-product-main-image-wrapper .image-container img");
  }

  // The photo set for what the card shows right now, or null when the product
  // has too few photos - Fast Simon's own slider then handles the card as on
  // the live theme.
  function cardCarousel(productElement) {
      const productId = productElement.dataset.productId;
      const colorName = selectedColorName(productElement);
      const cached = carousels.get(productElement);
      if (cached && cached.products === latestProducts && cached.productId === productId && cached.colorName === colorName) {
          return cached.images ? cached : null;
      }

      const carousel = { products: latestProducts, productId, colorName, images: null, index: 0 };
      carousels.set(productElement, carousel);

      let key = productKeyForCard(latestProducts, productElement);
      let data = key ? latestProducts[key] : null;
      const record = data ? null : colourRecords.get(productId);
      if (record) ({ key, data } = record);

      const images = data?.attributes?.find?.(attr => attr[0] === "Product images")?.[1];
      if (!Array.isArray(images) || images.length < 2) return null;

      const anchors = anchorsForProduct(key, colorAnchors(data));
      // The parent's own variants describe another colour, so trust the swatch / record here.
      const color = record
          ? colorName || record.color
          : currentCardColor(productElement, cardImage(productElement)?.src, images, productColorNames(data), anchors);
      const own = color ? imagesForCardColor(images, color, anchors) : [];

      if (!own.length) {
          console.warn(`[fastsimon carousel] could not determine colour for "${data.title}"`, { color, images });
      }

      carousel.images = own.length ? own : images;
      return carousel;
  }

  // "Product images" are full-size originals; ask Shopify's CDN for the size on screen.
  function sizedImageUrl(url, img) {
      const width = Math.min(2048, Math.ceil((img.clientWidth || 400) * (window.devicePixelRatio || 1) / 100) * 100);
      try {
          const sized = new URL(url, location.href);
          sized.searchParams.set("width", width);
          return sized.href;
      } catch (e) {
          return url;
      }
  }

  function showImage(img, url) {
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.src = sizedImageUrl(url, img);
  }

  // Fast Simon's position markers belong to its own slider, which never moves
  // here. Point them at this carousel instead; they mount on first hover/touch.
  function cardMarkers(productElement) {
      return [...productElement.querySelectorAll(".fs-product-main-image-wrapper .markers .marker")];
  }

  // Fast Simon caps its slider at the dashboard's marker count; keep the same cap.
  function carouselLength(productElement, carousel) {
      const markers = cardMarkers(productElement).length;
      return markers ? Math.min(carousel.images.length, markers) : carousel.images.length;
  }

  // Position of the photo on screen, or the last known one (Fast Simon swaps it on swatch hover).
  function shownIndex(productElement, carousel, count) {
      const shownStem = imageStemNoSize(cardImage(productElement)?.src || "");
      const shown = carousel.images.slice(0, count).findIndex(url => imageStemNoSize(url) === shownStem);
      return shown >= 0 ? shown : Math.min(carousel.index, count - 1);
  }

  function syncMarkers(productElement) {
      const carousel = carousels.get(productElement);
      if (!carousel?.images || carousel.productId !== productElement.dataset.productId) return;

      const markers = cardMarkers(productElement);
      const count = carouselLength(productElement, carousel);
      carousel.index = shownIndex(productElement, carousel, count);
      markers.forEach((marker, i) => {
          const selected = i === carousel.index;
          marker.classList.toggle("selected-marker", selected);
          marker.classList.toggle("marker-hover", !selected);
          if (marker.parentElement) marker.parentElement.style.display = i < count ? "" : "none";
      });
  }

  function stepCarousel(productElement, step) {
      const carousel = cardCarousel(productElement);
      const img = cardImage(productElement);
      if (!carousel || !img) return false;

      const count = carouselLength(productElement, carousel);
      carousel.index = (shownIndex(productElement, carousel, count) + step + count) % count;
      showImage(img, carousel.images[carousel.index]);
      syncMarkers(productElement);
      return true;
  }

  // After a swatch click, open on the new colour's own photo.
  function showCarouselStart(productElement) {
      const carousel = cardCarousel(productElement);
      const img = cardImage(productElement);
      if (!carousel || !img) return;

      carousel.index = 0;
      if (imageStemNoSize(img.src) !== imageStemNoSize(carousel.images[0])) showImage(img, carousel.images[0]);
      syncMarkers(productElement);

      if (carousel.colorName) {
          const baseAlt = img.alt.split(" - ")[0];
          img.alt = `${baseAlt} - ${carousel.colorName}`;
      }
  }

  const SWIPE_MIN_DISTANCE = 30;
  const TAP_SLOP = 10;
  // Fast Simon's arrows are 16x18px; a tap this close to one counts as the arrow.
  const ARROW_ZONE_X = 44;
  const ARROW_ZONE_Y = 44;
  const rootsWithListeners = new WeakSet();

  // Which arrow a point falls on, using the enlarged zone: -1, 1 or 0.
  function arrowZoneStep(productElement, x, y) {
      const container = productElement.querySelector(".fs-product-main-image-wrapper .image-container");
      if (!container) return 0;

      const box = container.getBoundingClientRect();
      const arrow = productElement.querySelector(".fs-product-main-image-wrapper .arrow-button");
      const arrowBox = arrow?.getBoundingClientRect();
      const centerY = arrowBox?.height ? arrowBox.top + arrowBox.height / 2 : box.top + box.height / 2;

      if (y < box.top || y > box.bottom || Math.abs(y - centerY) > ARROW_ZONE_Y) return 0;
      if (x >= box.left && x - box.left <= ARROW_ZONE_X) return -1;
      if (x <= box.right && box.right - x <= ARROW_ZONE_X) return 1;
      return 0;
  }

  // Capture-phase listeners on the grid's shadow root run before Fast Simon's
  // own listeners on the arrows (click) and the image (touchstart/touchend).
  function ensureCarouselListeners(element) {
      const root = element.getRootNode();
      if (rootsWithListeners.has(root)) return;
      rootsWithListeners.add(root);

      let swipe = null;
      let tap = null;
      // The card whose current gesture was already handled; its click is dropped.
      let handledCard = null;

      root.addEventListener("click", (e) => {
          const productElement = e.target.closest?.(".fs-results-product-card");
          if (!productElement) return;

          // Already handled on pointerup or as a swipe: don't step twice or open the product page.
          if (e.isTrusted && productElement === handledCard) {
              handledCard = null;
              e.preventDefault();
              e.stopPropagation();
              return;
          }

          const arrow = e.target.closest(".arrow-button");
          if (!arrow || !arrow.closest(".fs-product-main-image-wrapper")) return;

          if (stepCarousel(productElement, arrow.classList.contains("arrow-button-left") ? -1 : 1)) {
              e.preventDefault();
              e.stopPropagation();
          }
      }, true);

      // Touch taps are handled on pointerup: iOS can hold back the click of a
      // first tap on hover-revealed card UI, which made the arrows need two taps.
      root.addEventListener("pointerdown", (e) => {
          tap = null;
          handledCard = null;
          if (e.pointerType === "mouse" || !e.isPrimary) return;
          const productElement = e.target.closest?.(".fs-results-product-card");
          if (!productElement || !e.target.closest(".fs-product-main-image-wrapper .image-container")) return;
          tap = { productElement, x: e.clientX, y: e.clientY };
      }, true);

      root.addEventListener("pointercancel", () => { tap = null; }, true);

      root.addEventListener("pointerup", (e) => {
          if (!tap) return;
          const { productElement, x, y } = tap;
          tap = null;
          if (Math.abs(e.clientX - x) > TAP_SLOP || Math.abs(e.clientY - y) > TAP_SLOP) return;

          const step = arrowZoneStep(productElement, e.clientX, e.clientY);
          if (!step) return;

          if (stepCarousel(productElement, step)) {
              handledCard = productElement;
              return;
          }

          // Not a colour carousel (too few photos): enlarge Fast Simon's own arrow.
          const arrow = productElement.querySelector(`.fs-product-main-image-wrapper .arrow-button-${step < 0 ? "left" : "right"}`);
          if (arrow) {
              handledCard = productElement;
              arrow.click();
          }
      }, true);

      // Fast Simon mounts the markers on hover (touch taps emulate it too).
      root.addEventListener("mouseover", (e) => {
          const container = e.target.closest?.(".fs-product-main-image-wrapper .image-container");
          if (!container || container.contains(e.relatedTarget)) return;
          const productElement = container.closest(".fs-results-product-card");
          if (productElement && carousels.has(productElement)) setTimeout(() => syncMarkers(productElement), 0);
      }, true);

      root.addEventListener("touchstart", (e) => {
          swipe = null;
          if (e.touches.length !== 1) return;

          const container = e.target.closest?.(".fs-product-main-image-wrapper .image-container");
          const productElement = container?.closest(".fs-results-product-card");
          if (!productElement || !cardCarousel(productElement)) return;

          e.stopPropagation();
          swipe = { productElement, x: e.touches[0].clientX, y: e.touches[0].clientY };
      }, { capture: true, passive: true });

      root.addEventListener("touchend", (e) => {
          if (!swipe) return;
          const { productElement, x, y } = swipe;
          swipe = null;
          e.stopPropagation();

          const touch = e.changedTouches[0];
          const dx = touch.clientX - x;
          const dy = touch.clientY - y;
          if (Math.abs(dx) < SWIPE_MIN_DISTANCE || Math.abs(dx) <= Math.abs(dy)) return;

          if (stepCarousel(productElement, dx < 0 ? 1 : -1)) handledCard = productElement;
      }, { capture: true, passive: true });
  }

  function hooks() {
    var lang = Shopify.locale;
    console.log('lang:' + lang);

    window.SerpOptions.registerHook("serp-product-swatches", ({ swatchClick, element }) => {
      if (!swatchClick) return;

      const curProductElement = element.closest('.fs-results-product-card');
      if (!curProductElement) return;

      // The hook runs before Fast Simon marks the new swatch selected.
      setTimeout(() => showCarouselStart(curProductElement), 0);
    });

    window.SerpOptions.registerHook('serp-filters', ({ facets, element }) => {
      if (window.innerWidth < 480 && lang == 'fr') {
        if (element.querySelector('.fs-modern-filters-title-container .fs-modern-filters-title-text')) {
          element.querySelector('.fs-modern-filters-title-container .fs-modern-filters-title-text').innerHTML =
            'Filtrer et trier';
        }
        if (
          element.querySelector('.fs-modern-filters-sorting-title') &&
          element.querySelector('.fs-modern-filters-sorting-title').innerHTML == 'Sorting'
        ) {
          element.querySelector('.fs-modern-filters-sorting-title').innerHTML = 'Trier';
        }
        if (element.querySelector('.fs-modern-mobile-filters-clear-all-button')) {
          element.querySelector('.fs-modern-mobile-filters-clear-all-button').innerHTML = 'Effacer';
        }
        if (element.querySelectorAll('.fs-modern-mobile-filters-apply-button span').length == 3) {
          const resultsParts = element.querySelectorAll('.fs-modern-mobile-filters-apply-button span');
          resultsParts[0].innerHTML = 'Voir';
          resultsParts[2].innerHTML = 'items';
        }
      }
      if (window.innerWidth > 820 && lang == 'fr') {
        element.querySelectorAll('#fs_filter_couleur .filters-option-text').forEach((colorFilter) => {
          if (colorMap[colorFilter.innerHTML.toLowerCase()])
            colorFilter.innerHTML = colorMap[colorFilter.innerHTML.toLowerCase()];
        });
      }
    });

    window.SerpOptions.registerHook('serp-product-grid', ({ products, element }) => {
      latestProducts = products;
      registerAllAnchors(products);
      ensureCarouselListeners(element);

      const productCards = element.querySelectorAll('.fs-results-product-card');

      productCards.forEach((card) => {
        const titleElement = card.querySelector('.fs-product-title');

        if (titleElement && !titleElement.querySelector('.custom-title-icon')) {
          const titleText = titleElement.textContent.toLowerCase();

          if (titleText.includes('ice gripper') || titleText.includes('ice-gripper')) {
            const icon = document.createElement('img');
            icon.src =
              'https://cdn.shopify.com/s/files/1/0068/2292/0303/files/ICE_GRIPPER_ICON_2f73a267-9625-465e-8e4d-9ae62224a991.svg?v=1744823403';
            icon.alt = 'Ice Gripper Icon';
            icon.className = 'custom-title-icon';
            icon.style.width = '16px';
            icon.style.height = '16px';
            icon.style.marginLeft = '4px';
            icon.style.verticalAlign = 'middle';

            titleElement.appendChild(icon);
          }
        }
      });

      productCards.forEach((card) => {
        const oldTitle = card.querySelector('.fs-product-title');
        if (!oldTitle) return;

        // Replace with H3 if needed
        const newTitle = document.createElement('h3');
        newTitle.innerHTML = oldTitle.innerHTML;
        newTitle.className = oldTitle.className;
        newTitle.setAttribute('style', oldTitle.getAttribute('style'));
        oldTitle.parentNode.replaceChild(newTitle, oldTitle);

        // Make sure the icon is not already added
        if (newTitle.querySelector('.custom-heritage-icon')) return;

        const titleText = newTitle.textContent.toLowerCase();
        if (titleText.includes('heritage')) {
          const icon = document.createElement('img');
          icon.src = 'https://cdn.shopify.com/s/files/1/0068/2292/0303/files/Heritage-icon.svg?v=1757427943';
          icon.alt = 'Heritage';
          icon.className = 'custom-heritage-icon';
          icon.style.width = '16px';
          icon.style.height = '16px';
          icon.style.marginLeft = '4px';
          icon.style.verticalAlign = 'middle';

          newTitle.appendChild(icon);
        }
      });

      
      var parent = element.closest('#fs-serp-page');

      //change filters place
      if (
        parent &&
        !parent.querySelector('.top-center-container .filters-container') &&
        parent.querySelector('.filters-container') &&
        parent.querySelector('.top-center-container')
      ) {
        parent
          .querySelector('.top-center-container')
          .insertBefore(
            parent.querySelector('.filters-container'),
            parent.querySelector('.top-center-container').firstChild
          );
      }
      //change summaryWrapper place
      if (
        window.innerWidth > 820 &&
        parent &&
        !parent.querySelector('.buttons-wrapper .summaryWrapper') &&
        parent.querySelector('.buttons-wrapper') &&
        parent.querySelector('.summaryWrapper')
      ) {
        parent
          .querySelector('.buttons-wrapper')
          .insertBefore(parent.querySelector('.summaryWrapper'), parent.querySelector('.buttons-wrapper').firstChild);
      }
      if (
        window.innerWidth < 480 &&
        parent &&
        !parent.querySelector('.fs-top-right-buttons-wrapper .summaryWrapper') &&
        parent.querySelector('.fs-top-right-buttons-wrapper') &&
        parent.querySelector('.summaryWrapper')
      ) {
        parent
          .querySelector('.fs-top-right-buttons-wrapper')
          .insertBefore(
            parent.querySelector('.summaryWrapper'),
            parent.querySelector('.fs-top-right-buttons-wrapper').firstChild
          );
      }

      if (parent && lang == 'fr') {
        // Translate "Search results for"
        const title = parent.querySelector('.top-center-container .title');
        if (title) {
          const existingCustomTitle = parent.querySelector('.titleWrapper .title.cstm');
          if (existingCustomTitle) {
            existingCustomTitle.remove();
          }
          const titleFR = title.cloneNode(true);
          titleFR.innerHTML = titleFR.innerHTML.replace('Search results for', 'Résultats de recherche pour');
          titleFR.innerHTML = titleFR.innerHTML.replace('No results for', 'Aucun résultat pour');
          titleFR.classList.add('cstm');
          if (parent.querySelector('.titleWrapper')) {
            parent.querySelector('.titleWrapper').appendChild(titleFR);
          }

          title.style.display = 'none';
          titleFR.style.display = 'block';
        }
        //translate did-you-mean
        if (parent.querySelector('.did-you-mean')) {
          parent.querySelector('.did-you-mean').innerHTML = parent
            .querySelector('.did-you-mean')
            .innerHTML.replace('Did you mean', ' Vous voulez dire');
        }

        //translate no-results
        if (parent.querySelector('.fs-no-results')) {
          parent.querySelector('.fs-no-results').innerHTML = parent
            .querySelector('.fs-no-results')
            .innerHTML.replace(
              'No results found. Showing top popular products you might want to consider...',
              'Aucun résultat trouvé. Afficher les produits les plus populaires que vous pourriez considérer...'
            );
        }

        if (parent.querySelector('.clear-all-button')) {
          parent.querySelector('.clear-all-button').innerHTML = 'Tout effacer';
        }

        //translate filters
        if (parent.querySelector('.filters-button-wrapper')) {
          parent.querySelector('.filters-button-wrapper').innerHTML = 'FILTRES';
        }

        var totalResultsElement = parent.querySelector('.fs-total-results-text');
        if (totalResultsElement) {
          // Get the text content of the element
          const textContent = totalResultsElement.textContent;

          // Use a regular expression to separate the number and the text
          const number = textContent.match(/\d+/)[0]; // Match the number
          const text = textContent.replace(number, '').trim(); // Extract the text and trim any extra spaces

          // Replace the text with the translated text
          const translatedText = text.replace('results', 'résultats');

          // Set the new content of the element
          totalResultsElement.textContent = `${number} ${translatedText}`;
        }

        var filtersButton = parent.querySelector('.filters-button-wrapper');
        if (window.innerWidth < 820 && filtersButton && filtersButton.innerHTML == 'FILTRES') {
          filtersButton.innerHTML = 'FILTRES';
        }
      }

      for (const productElement of getProductElements(element)) {
        /* get product data */
        const productKey = productKeyForCard(products, productElement);
        const data = productKey ? products[productKey] : null;

        if (data) {
          // Drop only the " - COLOUR" suffix: splitting on any "-" cut "Wool-Like" to "Wool",
          // and writing it back to data.title made the next hook run show the cut title.
          const cleanTitle = (data.title || '').split(' - ')[0].trim();
          const titleElement = productElement.querySelector('.fs-product-title-wrapper .fs-product-title');
          if (titleElement && cleanTitle) {
            titleElement.textContent = cleanTitle;
          }

          if(data.imageSrcset) {
           querySelector('.price')
          }

          // clear old badges
          removeBadge(productElement);

          // get metafield badges
          let badges = getAttributeValues(data.attributes, 'custom.badges');
          if (!badges.length) {
            badges = getAttributeValues(data.metafields, 'custom.badges');
          }
          // render up to 2 badges with unique class
          badges.forEach((badgeText, i) => addBadge(productElement, badgeText, i));

          /* add if comparePrice exist*/
          if (
            data &&
            data.comparePrice &&
            data.price &&
            parseFloat(data.comparePrice) > 0 &&
            parseFloat(data.comparePrice) > parseFloat(data.price)
          ) {
            addSaleLabel(productElement, data);
          }

          /* Get the Color code */
          const url = data && data.productURL ? data.productURL : '';
          var colorName = data && data.variants ? GetColorName(data.variants) : '';
          var sanitizedColorName = sanitizeColorName(colorName);

          // color swatches images
          var cswatch = `<span class="color-swatch-container fs-color-swatch-container" data-alt-url="${url}"><span class="color-swatch fast-swatch-color-fallback fast-swatch-color-${sanitizedColorName} isp-product-color-swatch-${sanitizedColorName} selected" style="cursor: pointer;margin: 5px;display: block;transition: .2s all ease-in-out;position: relative;border: none !important;box-shadow: none !important;border-radius: 0px !important;max-height: 16px !important;max-width: 16px !important;width: 25px;height: 25px;" data-disabled="false" title="${colorName}"></span><span class="color-swatch-color-name fs-color-name" style="display: none;">${colorName}</span></span>`;
          var allColorSwatches = productElement.querySelectorAll('.color-swatch-container');

          if (allColorSwatches.length == 0) {
            if (productElement.querySelectorAll(`.fast-swatch-color-${sanitizedColorName}`).length === 0) {
              productElement.querySelector('.color-swatches').insertAdjacentHTML('beforeend', cswatch);
            }
          }

          // Select the parent element of the element with the class fs-product-title-search-term
          const parentElement = productElement.querySelector('.fs-product-title');
          const priceElement = productElement.querySelector('.price');

          // Check if the element exists
          if (priceElement) {
            // Get the text content of the element
            let priceText = priceElement.textContent;

            // Remove the "From" string
            priceText = priceText.toLowerCase();
            priceText = priceText.replace('from', '');

            // Set the modified text content back to the element
            priceElement.textContent = priceText.trim(); // trim() to remove extra whitespace
          }

          // Select the parent element of the element with the class fs-product-title-search-term
          var stringtoremove = colorName.toUpperCase().replace('_', ' ');
          stringtoremove = ' - ' + stringtoremove;

          // Check if the parent element exists
          if (parentElement) {
            // Get the text content of the parent element
            let textContent = parentElement.textContent;

            let regex = / - .*/;

            let newText = textContent.replace(regex, '');
            parentElement.textContent = newText;
          }

          // Replace the product title with an H3 element
          const newElement = document.createElement('h3');
          newElement.innerHTML = parentElement.innerHTML;
          newElement.className = parentElement.className;
          newElement.setAttribute('style', parentElement.getAttribute('style'));
          parentElement.parentNode.replaceChild(newElement, parentElement);

          // Title cleanup + Ice Gripper icon
          const titleWrapper = productElement.querySelector('.fs-product-title');
          if (titleWrapper) {
            const nameEl = titleWrapper.querySelector('a') || titleWrapper;
            nameEl.textContent = (nameEl.textContent || '').split(' - ')[0];

            // Ice Gripper icon
            if (
              /ice[\s-]?gripper/.test(nameEl.textContent.toLowerCase()) &&
              !nameEl.querySelector('.custom-title-icon')
            ) {
              const icon = new Image();
              icon.src =
                'https://cdn.shopify.com/s/files/1/0068/2292/0303/files/ICE_GRIPPER_ICON_2f73a267-9625-465e-8e4d-9ae62224a991.svg?v=1744823403';
              icon.alt = 'Ice Gripper Icon';
              icon.className = 'custom-title-icon';
              icon.style.width = '16px';
              icon.style.height = '16px';
              icon.style.marginLeft = '4px';
              icon.style.verticalAlign = 'middle';
              nameEl.appendChild(icon);
            }

            // Heritage icon
            if (
              nameEl.textContent.toLowerCase().includes('heritage') &&
              !nameEl.querySelector('.custom-heritage-icon')
            ) {
              const icon = document.createElement('img');
              icon.src = 'https://cdn.shopify.com/s/files/1/0068/2292/0303/files/Heritage-icon.svg?v=1757427943';
              icon.alt = 'Heritage';
              icon.className = 'custom-heritage-icon';
              icon.style.width = '16px';
              icon.style.height = '16px';
              icon.style.marginLeft = '4px';
              icon.style.verticalAlign = 'middle';
              nameEl.appendChild(icon);
            }
          }
        }
      }
    });
  }

  // execution here
  if (window.SerpOptions) {
    hooks();
  } else {
    window.addEventListener('fast-serp-ready', function () {
      hooks();
    });
  }